import { render, staticRenderFns } from "./ComboOfferMedia.vue?vue&type=template&id=31473d8f"
import script from "./ComboOfferMedia.vue?vue&type=script&lang=js"
export * from "./ComboOfferMedia.vue?vue&type=script&lang=js"
import style0 from "./ComboOfferMedia.vue?vue&type=style&index=0&id=31473d8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports